import { render } from "./About.vue?vue&type=template&id=4c6ef0d5"
const script = {}
script.render = render

export default script